import bigBell from '../images/big-bell.png'
import imageMissing from './missing.png'
import billConfirmed from './bill-confirmed.png'
import billOrdered from './bill-ordered.png'
import chinaImg from './china.png'
import rescanQR from './rescan-qr.png'
import iconFailed from './icon-failed.png'
import googleLogo from './google_logo.svg'
import tripadvisorLogo from './tripadvisor_logo.png'
import reviewImage from './review-image.png'
import tickGreenIcon from './tick-green-icon.png'
import instagramLogo from './instagram_logo.png'
import LINE from './LINE.png'

// ảnh con cá trong trường hợp muốn fallback image
const fallbackImage =
  'https://dev.cdn.capiorder.com/images/images/000/000/426/original/115.jpeg?1657275203'

export {
  bigBell,
  imageMissing,
  billConfirmed,
  billOrdered,
  chinaImg,
  rescanQR,
  fallbackImage,
  iconFailed,
  googleLogo,
  tripadvisorLogo,
  reviewImage,
  tickGreenIcon,
  instagramLogo,
  LINE,
}
